var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cols-min-minmax wh-full scroll-y"},[_c('navigator'),_c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }